export default __webpack_public_path__ + "static/media/caffe.b2f229d5.svg";